import React, { useEffect, useState } from 'react'
import { useFormik } from 'formik'
import * as Yup from "yup"
import { Form, Label, Input, Card, CardBody, CardHeader, CardFooter, Button, FormGroup, FormFeedback } from 'reactstrap'
import Flatpickr from "react-flatpickr";
import { useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { useDispatch } from 'react-redux';
import { submitClaimLink, viewClaimLink } from 'store/actions';
import { toast } from 'react-toastify';
import DatePicker from 'components/Common/DatePicker';
const CustCreateClaim = () => {

    const { hashkey } = useParams();
    const dispatch = useDispatch();
    const [defaultValues, setDefaultValues] = useState({
        "claim_incident_date": "",
        "claim_filed_date": "",
        "reason": "",
        "amount": "",
    })
    const [files, setFiles] = useState({
        file_1: "",
        file_2: "",
        file_3: "",
        file_4:""
    })
    const { custClaimForm, loading, error, responseMsg } = useSelector(state => state.ClaimFormReducer)
    useEffect(() => {
        dispatch(viewClaimLink({ "hashkey": hashkey }))
    }, [])



    const validation = useFormik({
        enableReinitialize: true,

        initialValues: defaultValues
        ,
        validationSchema: Yup.object({
            claim_incident_date: Yup.string().required("Please Enter Claim Incident Date"),
            claim_filed_date: Yup.string().required("Please Enter Claim Filed Date"),
            reason: Yup.string().required("Please Enter reason"),
            amount: Yup.string().required("Please Enter amount"),
        }),
        onSubmit: values => {

            console.log("KKKKKKKKKKKKKKKK")

            const formData = new FormData();
            formData.append("hashkey", hashkey);
            formData.append("claim_incident_date", values.claim_incident_date);
            formData.append("claim_filed_date", values.claim_filed_date);
            formData.append("reason", values.reason);
            formData.append("amount", values.amount);
            formData.append("files", files.file_1);
            formData.append("files", files.file_2);
            formData.append("files", files.file_3);
            formData.append("files", files.file_4);


            dispatch(submitClaimLink(formData))


        },
    })

    useEffect(() => {
        if (custClaimForm && custClaimForm?.claims?.length > 0) {
            setDefaultValues({
                "claim_incident_date": custClaimForm.claims[0].claim_incident_date,
                "claim_filed_date": custClaimForm.claims[0].claim_filed_date,
                "reason": custClaimForm.claims[0].reason,
                "amount": custClaimForm.claims[0].amount,
            })
        }
    }, [custClaimForm])


    useEffect(() => {
        if (error) {
            toast.error(error)
        }
    }, [error])

    useEffect(() => {
        if (responseMsg) {
            toast.success(responseMsg);
            dispatch(viewClaimLink({ "hashkey": hashkey }))
        }
    }, [responseMsg])

    console.log(validation.errors)
    return (
        <div className='container'>
            <Card className='mt-5 mx-auto' style={{ maxWidth: "800px" }}>
                <CardHeader tag={'h2'}>Create Claim </CardHeader>
                <CardBody>

                    <Form
                        onSubmit={e => {
                            e.preventDefault()
                            validation.handleSubmit()

                        }}>
                        <FormGroup>
                            <Label className="form-label mt-3">Customer Name</Label>
                            <Input
                                type='text'
                                name=''
                                disabled
                                value={
                                    custClaimForm.customer ? custClaimForm.customer[0].customer_business_type === "Company" ? custClaimForm.customer[0].company_name : custClaimForm.customer[0].first_name + " " + custClaimForm.customer[0].last_name : ""
                                }
                            />
                        </FormGroup>

                        <FormGroup>
                            <Label className="form-label mt-3">Product Name</Label>
                            <Input
                                type='text'
                                name=''
                                disabled
                                value={custClaimForm.policy ? custClaimForm.policy[0].product_name : ""}
                            />
                        </FormGroup>

                        <FormGroup>
                            <Label className="form-label mt-3">Policy Number</Label>
                            <Input
                                type='text'
                                name=''
                                disabled
                                value={custClaimForm.policy ? custClaimForm.policy[0].policy_number : ""}
                            />
                        </FormGroup>

                        <FormGroup>
                            <Label className="form-label mt-3">Claim Incident Date</Label>
                            <DatePicker
                                value={validation.values.claim_incident_date || ""}
                                name={"claim_incident_date"}
                                placeholder="Add Claim Incident Date"
                                disabled={custClaimForm && custClaimForm?.claims?.length > 0}
                                onChange={(date) => {
                                    console.log("Selected Date:", date);
                                    validation.handleChange(date);
                                }}
                            />

                            <div className='text-danger' style={{ fontSize: "10px" }}>

                                {validation.errors.claim_incident_date}
                            </div>

                        </FormGroup>

                        <FormGroup>
                            <Label className="form-label mt-3">Claim Filed Date​</Label>

                            <DatePicker
                                name={"claim_filed_date"}
                                placeholder="Add Filed Incident Date"
                                disabled={custClaimForm && custClaimForm?.claims?.length > 0}
                                value={validation.values.claim_filed_date || ""}
                                onChange={(date) => {
                                    console.log("Selected Date:", date);
                                    validation.handleChange(date);
                                }}
                            />

                            <div className='text-danger' style={{ fontSize: "10px" }}>
                                {validation.errors.claim_filed_date}
                            </div>

                        </FormGroup>
                        <FormGroup>
                            <Label className="form-label mt-3">Claim Reason</Label>
                            <Input
                                id="reason"
                                type="text"
                                name='reason'
                                placeholder='Claim Reason'
                                disabled={custClaimForm && custClaimForm?.claims?.length > 0}
                                validate={{
                                    required: { value: true },
                                }}
                                onChange={validation.handleChange}
                                onBlur={validation.handleBlur}
                                value={validation.values.reason || ""}
                                invalid={
                                    validation.touched.reason && validation.errors.reason
                                        ? true
                                        : false
                                }

                            />

                            {validation.touched.reason || validation.errors.reason ? (
                                <FormFeedback type="invalid">
                                    {validation.errors.reason}
                                </FormFeedback>
                            ) : null}
                        </FormGroup>
                        <FormGroup>
                            <Label className="form-label mt-3">Claim Amount Requested</Label>
                            <Input
                                id="amount"
                                name="amount"
                                type="number"
                                placeholder='Claim Amount Requested'
                                disabled={custClaimForm && custClaimForm?.claims?.length > 0}
                                validate={{
                                    required: { value: true },
                                }}
                                onChange={validation.handleChange}
                                onBlur={validation.handleBlur}
                                value={validation.values.amount || ""}
                                invalid={
                                    validation.touched.amount && validation.errors.amount
                                        ? true
                                        : false
                                }
                            />

                            {validation.touched.amount || validation.errors.amount ? (
                                <FormFeedback type="invalid">
                                    {validation.errors.amount}
                                </FormFeedback>
                            ) : null}
                        </FormGroup>


                        <FormGroup>
                            <Label className="form-label mt-3">1. Files/Docs</Label>
                            <Input
                                type="file"
                                placeholder='Please Upload Files here'
                                disabled={custClaimForm && custClaimForm?.claims?.length > 0}
                                //value={files.file_1}
                                onChange={(e) => setFiles({
                                    ...files,
                                    file_1: e.target.files[0]
                                })}
                            />

                            <div>
                                <img src={custClaimForm && custClaimForm?.files?.length > 0 && custClaimForm?.files[0]?.file} width={"250px"} className='mt-2'/>
                            </div>
                        </FormGroup>

                        <FormGroup>
                            <Label className="form-label mt-3">2. Files/Docs</Label>
                            <Input
                                type="file"
                                placeholder='Please Upload Files here'
                                disabled={custClaimForm && custClaimForm?.claims?.length > 0}
                                //  value={files.file_2}
                                onChange={(e) => setFiles({
                                    ...files,
                                    file_2: e.target.files[0]
                                })}
                            />

                            <div>
                                <img src={custClaimForm && custClaimForm?.files?.length > 0 && custClaimForm?.files[1]?.file} width={"250px"} className='mt-2' />
                            </div>
                        </FormGroup>

                        <FormGroup>
                            <Label className="form-label mt-3">3. Files/Docs</Label>
                            <Input
                                type="file"
                                placeholder='Please Upload Files here'
                                disabled={custClaimForm && custClaimForm?.claims?.length > 0}
                                // value={files.file_3}
                                onChange={(e) => setFiles({
                                    ...files,
                                    file_3: e.target.files[0]
                                })}
                            />

                            <div>
                                <img src={custClaimForm && custClaimForm?.files?.length > 0 && custClaimForm?.files[2]?.file} width={"250px"} className='mt-2' />
                            </div>
                        </FormGroup>

                        <FormGroup>
                            <Label className="form-label mt-3">4. Files/Docs</Label>
                            <Input
                                type="file"
                                placeholder='Please Upload Files here'
                                disabled={custClaimForm && custClaimForm?.claims?.length > 0}
                                //value={files.file_1}
                                onChange={(e) => setFiles({
                                    ...files,
                                    file_4: e.target.files[0]
                                })}
                            />

                            <div>
                                <img src={custClaimForm && custClaimForm?.files?.length > 0 && custClaimForm?.files[3]?.file} width={"250px"} className='mt-2'/>
                            </div>
                        </FormGroup>

                        <FormGroup>
                            {custClaimForm && custClaimForm?.claims?.length > 0 ?

                                <Button
                                    color='secondary'
                                    className='float-end'
                                    type='button'
                                    disabled={true}
                                >Already Submitted</Button>
                                :

                                <Button
                                    color='primary'
                                    className='float-end'
                                    type='submit'
                                    disabled={custClaimForm && custClaimForm?.claims?.length > 0}
                                >Submit</Button>}
                        </FormGroup>
                    </Form>
                </CardBody>
                <CardFooter>
                </CardFooter>
            </Card>
        </div>
    )
}

export default CustCreateClaim